import clsx from 'clsx';
import { usePresence } from 'motion/react';
import { useEffect } from 'react';
import Modal from '@/components/Modals/Core';
const Overlay = () => {
  const [isPresent, safeToRemove] = usePresence();
  useEffect(() => {
    if (isPresent) {
      return () => {};
    }
    const timeout = setTimeout(safeToRemove, 350);
    return () => clearTimeout(timeout);
  }, [isPresent, safeToRemove]);
  return <Modal.Overlay asChild forceMount data-sentry-element="Modal.Overlay" data-sentry-component="Overlay" data-sentry-source-file="Overlay.tsx">
      <div className={clsx('fixed inset-0 z-[9998] bg-black/50 backdrop-blur-px will-change-[opacity]', {
      'animate-fadeOut': !isPresent,
      'animate-fadeIn': isPresent
    })} key="overlay" />
    </Modal.Overlay>;
};
export default Overlay;